<template>
  <div class="slider">
    <div class="shape"></div>
    <div class="container">
      <div class="heading text-center">
        <h3>Categories</h3>
        <p>Are you ready for your next lesson ?</p>
      </div>
      <div class="row">
        <div class="col-md-4" v-for="(interest, index) in categories" :key="index">
          <router-link style="text-decoration: none" :to="{ name: 'Category', params: { id: interest.id }}">
            <div class="card">
              <img :src="url + '/uploads/interest/covers/' + interest.coverName" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title" style="min-height: 80px;"><a href="#">{{ interest.name }}</a></h5>
                <p class="card-text"></p>
                <span class="person">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 591.96 376.14" style="enable-background:new 0 0 591.96 376.14;" xml:space="preserve">
              <path class="st0" d="M341.08,158.98c4.92,2.03,8.52,3.56,12.16,5.01c13.08,5.23,25.23,12.1,36.15,21c3.7,3.02,6.44,3.27,10.24-0.04
                c9.64-8.39,21.14-13.8,32.87-18.96c-0.57-4.28-4.35-5.83-6.74-8.35c-17.66-18.68-24.14-40.55-17.31-65.36
                c6.93-25.15,23.72-41.22,49.03-47.74c29.01-7.47,59.14,5.57,74.49,31.78c14.94,25.51,10.81,58.97-9.98,80.43
                c-2.53,2.61-5.28,5.02-7.87,7.47c0.29,3.43,3.34,3.04,5.18,3.87c39.71,17.98,63.44,48.41,71.46,91.19c1.36,7.26,1.07,14.6,1.2,21.93
                c0.06,3.34-1.29,4.92-4.72,4.73c-2.33-0.13-4.66,0-7,0c-39.66,0-79.31,0-118.97,0c-2.33,0-4.67-0.07-7,0.03
                c-6.41,0.27-6.43,0.3-6.34,6.88c0.09,6.66,0.04,13.33,0.36,19.99c1.59,32.5-25.66,62.37-61.29,63.24c-1.33,0.03-2.67,0.06-4,0.06
                c-58.32,0-116.64-0.01-174.95,0.01c-22.06,0-40.16-8.11-53.61-25.93c-8.36-11.07-11.9-23.74-12.13-37.37
                c-0.12-6.98,0.27-14,0.96-20.94c0.44-4.44-1.01-6.18-5.33-5.97c-2.33,0.11-4.66,0-7,0c-38.66,0-77.31,0-115.97,0c-2,0-4,0.03-6-0.01
                c-8.95-0.14-9.03-0.15-8.97-8.7c0.22-31.42,11.22-58.52,32.72-81.39c10.88-11.57,23.72-20.34,38.16-26.86
                c2.32-1.05,5.02-1.44,7.31-4.32c-19.28-15.83-28.8-36.07-26.74-61.2c1.34-16.33,8.21-30.15,19.74-41.5
                c24.88-24.5,64.36-25.88,91-3.33c10.72,9.08,17.92,20.52,21.43,34.15c3.41,13.24,2.76,26.27-1.47,39.35
                c-4.33,13.39-13.27,23.43-24.04,33.21c13.38,6.13,25.28,11.97,35.49,20.61c2.02,1.71,4.09,1.96,6.28,0.21
                c14.66-11.69,31-20.37,50.75-27c-28.97-21.04-43.23-47.92-40.27-82.14c2-23.2,12.61-42.69,30.67-57.58
                c35.68-29.41,88.13-24.84,118.92,9.69C386.58,59.01,394.73,118.79,341.08,158.98z M295.36,357.33c11.33,0,22.65,0,33.98,0
                c18.66-0.01,37.32,0.36,55.96-0.12c26.58-0.69,44.07-18.67,44.48-45.16c0.14-8.98-0.33-17.91-1.63-26.87
                c-10.19-70.14-76.45-121.24-146.83-113.29c-73.08,8.26-126.11,72.1-120.26,145.25c0.8,10.02,4.68,18.62,11.41,25.99
                c9.66,10.59,21.96,14.31,35.93,14.24C237.4,357.23,266.38,357.33,295.36,357.33z M362.03,85.63c0.1-37.26-29.89-67.28-67.16-67.2
                c-36.46,0.07-66.68,30.27-66.84,66.82c-0.17,36.63,30.72,67.44,67.47,67.3C332.03,152.41,361.93,122.33,362.03,85.63z
                M508.35,267.14c18.33,0,36.65,0.03,54.98-0.01c9.74-0.02,10.07-0.29,8.22-9.23c-2.38-11.49-6.58-22.3-12.68-32.38
                c-29.82-49.29-96.63-63.18-143.08-29.69c-7.81,5.63-7.96,5.8-2.12,12.83c12.73,15.32,22.03,32.53,27.79,51.51
                c1.7,5.61,4.39,7.17,9.91,7.09C470.36,266.96,489.35,267.13,508.35,267.14z M83.14,267.14c18.33,0,36.66,0.03,54.99-0.01
                c8.57-0.02,8.66-0.05,11.12-7.77c4.19-13.09,9.99-25.36,17.52-36.89c3.84-5.88,7.94-11.54,12.57-16.77
                c3.01-3.39,2.54-5.65-1.07-7.91c-2.25-1.41-4.29-3.17-6.53-4.61c-33.62-21.62-77.26-20.89-110.26,1.99
                c-21.47,14.88-34.98,35.3-41.08,60.62c-2.63,10.93-2.22,11.33,8.73,11.35C47.15,267.16,65.14,267.14,83.14,267.14z M69.44,109.47
                c-0.17,27.13,21.35,49.07,48.29,49.24c26.78,0.17,49.08-21.69,49.45-48.47c0.37-26.31-22.18-49.2-48.64-49.36
                C91.69,60.71,69.6,82.57,69.44,109.47z M472.91,158.71c26.87,0.21,49.19-21.67,49.35-48.38c0.16-26.91-21.69-49.28-48.34-49.47
                c-26.75-0.19-49,21.7-49.29,48.52C424.33,136.31,446.05,158.5,472.91,158.71z"/>
              </svg>
              20
            </span>
                <span class="like">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 598.63 532.65" style="enable-background:new 0 0 598.63 532.65;" xml:space="preserve">
              <path class="st0" d="M0,167.19c0.52-33.81,13.51-75.98,44.4-111.53C69.56,26.7,101.22,8.73,139.17,2.6
                c63.18-10.2,113.5,12.43,153.39,61.02c1.06,1.29,2.19,2.53,3.11,3.91c2.72,4.09,4.89,3.17,7.53-0.3
                c8.71-11.42,18.57-21.74,29.57-31.04C401.35-21.7,502.14-6.71,555.04,56.78c36.69,44.04,49.08,95.04,41.43,151.3
                c-5.26,38.67-22.56,72.14-45.62,102.95c-25.08,33.51-54.87,62.6-86.23,90.06c-45.86,40.15-92.2,79.76-138.21,119.74
                c-11.64,10.12-24.2,15.03-39.47,9.51c-3.81-1.38-7.27-3.37-10.3-6.01c-61.02-53.16-124.28-103.77-182.23-160.4
                c-21.48-20.99-41.26-43.51-57.78-68.7C13.66,260.23-0.19,222.27,0,167.19z M34.82,191.95c-0.27,17.03,7.83,44.1,22.13,69.59
                c16.65,29.66,39.02,54.7,62.92,78.49c31.67,31.52,65.84,60.27,99.62,89.45c24.45,21.12,49.04,42.1,73.58,63.11
                c6.08,5.2,6.17,5.24,12.34,0.04c7.64-6.44,15.2-12.98,22.74-19.54c50.53-43.91,102.71-85.97,150.48-132.99
                c24.28-23.9,47.26-49.06,63.39-79.36c31.09-58.4,30.71-116.37-6.31-172.04c-28.32-42.59-83.82-62.83-132.75-50.39
                c-29.35,7.46-51.91,24.98-70.41,48.22c-5.38,6.76-9.85,14.24-15.01,21.19c-9.77,13.15-26.59,13.16-36.34,0.13
                c-1.99-2.66-3.75-5.5-5.59-8.28C267.64,87.59,258.27,76.9,247.8,67C195.52,17.52,113.23,28.16,70.24,79.02
                C45.69,108.08,35.14,142,34.82,191.95z"/>
              </svg>
              10%
            </span>
                <a href="#" class="discover">Discover</a>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      categories: [],
      url: process.env.VUE_APP_ROOT_IMAGES_API,
    }
  },
  async mounted() {
    await axios.get('/api/v3/interests')
        .then((response) => {
          this.categories = response.data;
        })
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/categories/styles.scss";

.slider {
  background: #F7F7F7;
  padding: 212px 0;
  overflow: hidden;
  position: relative;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 124px 0;
  }

  .shape {
    position: absolute;
    width: 1920px;
    height: 1952px;
    left: 0px;
    top: -822px;
    background: radial-gradient(52.1% 52.1% at 50% 50%, #00E384 0%, rgba(255, 255, 255, 0) 100%);
    @media (min-width: $width1) and (max-width: $width2) {
      width: 908px;
      height: 919px;
      left: -427px;
      top: -229px;
    }
  }

  .container {
    padding: 0 100px;
    @media (min-width: $width1) and (max-width: $width2) {
      padding: 0 20px;
    }

    .heading {
      margin-bottom: 74px;
      position: relative;
      @media (min-width: $width1) and (max-width: $width2) {
        margin-bottom: 30px;
      }

      h3 {
        font-weight: 500;
        font-size: 64px;
        line-height: 69px;
        @media (min-width: $width1) and (max-width: $width2) {
          font-size: 36px;
          text-align: justify;
          line-height: 33px;
        }
      }

      p {
        font-weight: 300;
        font-size: 24px;
        line-height: 131%;
        @media (min-width: $width1) and (max-width: $width2) {
          font-size: 14px;
          text-align: justify;
        }
      }
    }

    .card {
      margin-bottom: 74px;
      @media (min-width: $width1) and (max-width: $width2) {
        margin-bottom: 20px;
      }

      .card-body {
        padding: 44px 43px 39px 43px;
        @media (min-width: $width1) and (max-width: $width2) {
          padding: 31px 39px 31px 39px;
        }

        h5 {
          @media (min-width: $width1) and (max-width: $width2) {
            margin-bottom: 11px;
          }

          a {
            font-weight: bold;
            font-size: 36px;
            line-height: 111.8%;
            text-transform: capitalize;
            color: #1A191D;
            text-decoration: none;
          }

        }

        p {
          font-weight: 300;
          font-size: 12px;
          line-height: 161%;
          text-align: justify;
          color: #707070;
          margin-bottom: 79px;
          @media (min-width: $width1) and (max-width: $width2) {
            margin-bottom: 35px;
          }
        }

        span {
          font-weight: 300;
          font-size: 12px;
          line-height: 161%;
          text-align: justify;
          color: #707070;

          svg {
            width: 13px;
          }
        }

        .like {
          margin-left: 22px;
          @media (min-width: $width1) and (max-width: $width2) {
            margin-left: 10px;
          }
        }

        .discover {
          font-weight: 500;
          font-size: 12px;
          text-transform: capitalize;
          color: #FFFFFF;
          background: #00C66A;
          border-radius: 9px;
          text-decoration: none;
          padding: 5px 33px;
          float: right;
          display: none;
          @media (min-width: $width1) and (max-width: $width2) {
            display: inline-block;
          }

        }
      }
    }
  }

}
</style>
